import React, { useEffect, useState } from 'react';

import { CheckCircleIcon, UncheckIcon } from '../../../icons';
import { ModalFooter } from '../../elements/modalFooter';

const OfferCheckStatus = ({
  cncCode,
  customerForm,
  documents,
  customerFormValue,
  docsValues,
  modalData,
  handleCancelClick,
  handleSubmit,
}) => {
  const [tableData, setTableData] = useState({});

  useEffect(() => {
    const { data, actions } = customerForm;

    const rejectedActions = [];
    const approvedActions = [];
    const actn = actions.find(
      (action) => action.name === customerFormValue[cncCode][data.id]
    );
    if (actn) {
      if (actn.name === 'rejected') {
        rejectedActions.push({
          label: 'Φόρμα Νέου Πελάτη',
          status: actn?.label,
        });
      } else {
        approvedActions.push({
          label: 'Φόρμα Νέου Πελάτη',
          status: actn?.label,
        });
      }
    }

    Object.entries(docsValues[cncCode] || {}).forEach((item) => {
      const [key, value] = item;
      const docData = documents.data.find((doc) => doc.docCode.value === key);
      const actionTaken = docData?.actions?.find(
        (action) => action.name === value
      );
      let friendlyName = docData?.friendlyName?.value;

      if (actionTaken.name === 'rejected') {
        rejectedActions.push({
          label: friendlyName,
          status: actionTaken?.label,
        });
      } else {
        approvedActions.push({
          label: friendlyName,
          status: actionTaken?.label,
        });
      }
    });

    setTableData({ approvedActions, rejectedActions });
  }, [docsValues, cncCode, documents.data, customerForm, customerFormValue]);

  return (
    <div className="flex flex-col lg:gap-6 gap-5 lg:h-[calc(100vh-200px)] h-[calc(100vh-80px)] overflow-y-auto scrollbar">
      <h3 className="lg:text-center">
        {modalData.label} - {cncCode}
      </h3>
      <div className="flex flex-col gap-4">
        <div className="flex px-6 justify-end items-center">
          {/* <h5 className="text-grenite">Defination</h5> */}
          <h5 className="text-grenite">Status</h5>
        </div>
        {tableData?.rejectedActions?.map(({ label, status }) => {
          return (
            <div
              key={label}
              className="flex gap-6 py-3 px-6 justify-between items-center bg-powdergrey rounded-xl"
            >
              <span className="text-body text-grenite lg:w-7/12"> {label}</span>
              <div className="flex items-center gap-2">
                <UncheckIcon className={`${'stroke-primary'}`} />
                <h6 className="text-primary">{status}</h6>
              </div>
            </div>
          );
        })}
        <span className="h-[.5px] w-full bg-fadedgrey"></span>
        {tableData?.approvedActions?.map(({ label, status }) => {
          return (
            <div
              key={label}
              className="flex gap-6 py-3 px-6 justify-between items-center bg-powdergrey rounded-xl"
            >
              <span className="text-body text-grenite lg:w-7/12"> {label}</span>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className={`${'stroke-success'}`} />
                <h6 className="text-success">{status}</h6>
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex gap-3 items-center justify-center">
        <ModalFooter
          handleCancelClick={handleCancelClick}
          handleOkClick={handleSubmit}
          saveBtnText="Επιβεβαίωση"
          className="max-lg:flex-col max-lg:col-reverse max-lg:w-full"
        />
      </div>
    </div>
  );
};

export default OfferCheckStatus;
